<template>
  <div>
    <my-menu menu-name="msg"></my-menu>

    <div style="margin: 100px auto;width: 70%;border: 1px solid #e6e6e6;padding: 19px;">
      <div style="border-bottom: 1px solid #e6e6e6;padding-bottom: 15px;margin-bottom: 15px;">
        <h2 style="padding: 0;margin: 0;">有偿资讯</h2>
      </div>
      <ul style="padding: 0;">
        <li style="line-height: 20px;display: block;height: 20px;padding: 5px 0;">
          <i style="background-color: #666;vertical-align: middle;display: inline-block;width: 3px;height: 3px;margin-right: 10px;"></i>
          <b>怎么学英语</b>
          <span style="font-size: 11px;color: #aaa;float:right;">2020-03-25 14:53</span>
        </li>
        <div style="width: 100%;height: 4rem;">
          <div style="float: left;width: 86%;height: auto;padding-left: 18px;">学英语并无捷径和秘诀可寻。但是经验告诉我们，总有些技巧和方法可以对学习有些帮助。下面所述这些方法，都是实际可行的，并不是空谈和理论，大家依自己的需要可以选择几项去试一试。</div>
          <div style="float: right;width: 10%; text-align: center;">
            <button @click="subHandle" style="color: red;border: 1px solid #8c8c8c;-webkit-border-radius: 3px;-moz-border-radius: 3px;border-radius: 3px;">¥2订阅</button>
          </div>
        </div>
        <li style="line-height: 20px;display: block;height: 20px;padding: 5px 0;">
          <i style="background-color: #666;vertical-align: middle;display: inline-block;width: 3px;height: 3px;margin-right: 10px;"></i>
          <b>十个妙招教你快速练就好口语</b>
          <span style="font-size: 11px;color: #aaa;float:right;">2019-09-01 09:13</span>
        </li>
        <div style="width: 100%;height: 4rem;">
          <div style="float: left;width: 86%;height: auto;padding-left: 18px;">英语口语好，到底有多重要？口语学习中，我们都太重视说而忽略了听，这样也就很难发现自己口语的缺陷究竟在哪里。十个妙教你用最简单的方法，学最流利的英语口语，快速天掌握基本对话。</div>
          <div style="float: right;width: 10%; text-align: center;">
            <button @click="subHandle" style="color: red;border: 1px solid #8c8c8c;-webkit-border-radius: 3px;-moz-border-radius: 3px;border-radius: 3px;">¥2订阅</button>
          </div>
        </div>
        <li style="line-height: 20px;display: block;height: 20px;padding: 5px 0;">
          <i style="background-color: #666;vertical-align: middle;display: inline-block;width: 3px;height: 3px;margin-right: 10px;"></i>
          <b>高考英语提分秘籍来了！</b>
          <span style="font-size: 11px;color: #aaa;float:right;">2019-06-23 15:09</span>
        </li>
        <div style="width: 100%;height: 4rem;">
          <div style="float: left;width: 86%;height: auto;padding-left: 18px;">高考提分秘籍来了，最后冲刺还能再提5分！相信高考临近的这个时候，每一位奋战在高考前线的同学都进入“两耳不闻窗外事，一心只做冲刺卷”的状态。</div>
          <div style="float: right;width: 10%; text-align: center;">
            <button @click="subHandle" style="color: red;border: 1px solid #8c8c8c;-webkit-border-radius: 3px;-moz-border-radius: 3px;border-radius: 3px;">¥2订阅</button>
          </div>
        </div>
        <li style="line-height: 20px;display: block;height: 20px;padding: 5px 0;">
          <i style="background-color: #666;vertical-align: middle;display: inline-block;width: 3px;height: 3px;margin-right: 10px;"></i>
          <b>高中英语阅读理解解题技巧，教你一眼看出正确答案</b>
          <span style="font-size: 11px;color: #aaa;float:right;">2019-05-05 10:03</span>
        </li>
        <div style="width: 100%;height: 4rem;">
          <div style="float: left;width: 86%;height: auto;padding-left: 18px;">提起英文阅读理解，很多同学是一把“辛酸泪”，生词多，读不懂；即使单词都认识，却常常还是读不懂。一旦读不懂，就会影响做题的时间和质量，高中英语考试中阅读理解的九大题型和解题技巧，帮助你提高做题的正确率。</div>
          <div style="float: right;width: 10%; text-align: center;">
            <button @click="subHandle" style="color: red;border: 1px solid #8c8c8c;-webkit-border-radius: 3px;-moz-border-radius: 3px;border-radius: 3px;">¥2订阅</button>
          </div>
        </div>
      </ul>
    </div>

    <div class="dialog" v-show="dialogShow">
      <div style="background-color: #f3f3f3;border-bottom: solid 1px #eee;margin: 0;z-index: auto;">
        <span style="display: inline-block;height: 20px;padding: 10px 20px;border: none 0;">请扫描支付</span>
        <span @click="closeDialog" style="font-family: Verdana;font-size: 14px;line-height: 20px;color: #999;text-align: center;display: inline-block;width: 20px;height: 20px;position: absolute;z-index: 1;top: 10px;right: 10px;cursor: pointer;">×</span>
      </div>
      <div style="width: 342.4px;height: 465.6px;">
        <img src="../assets/images/qrcode.png" style="width: 100%;height: 100%;"/>
      </div>
    </div>

    <my-footer></my-footer>
  </div>
</template>

<script>
  import MyFooter from '@/components/Footer'
  import MyMenu from '@/components/Menu'
  export default {
    name: 'Messages',
    components: {
      MyFooter, MyMenu
    },
    data () {
      return {
        dialogShow: false
      }
    },
    methods: {
      subHandle () {
        this.dialogShow = !this.dialogShow
      },
      closeDialog () {
        this.dialogShow = !this.dialogShow
      }
    }
  }
</script>

<style scoped>
  .dialog {
    position: absolute;
    top: 100px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
    z-index: 99999;
    /*width: 300px;*/
    /*height: 500px;*/
    /*background-color: red;*/
    -webkit-box-shadow: 0 0 50px rgba(0, 0, 0, .3);
    -moz-box-shadow: 0 0 50px rgba(0, 0, 0, .3);
    box-shadow: 0 0 50px rgba(0, 0, 0, .3);
  }
</style>



// WEBPACK FOOTER //
// Messages.vue?a8fe76fe